import { Directive, HostListener } from '@angular/core'

/**
 * Verhindert die Clickpropagation bei gestappelten Elementen.
 */
@Directive({
  selector: '[libClickStopPropagation]',
})
export class ClickStopPropagationDirective {
  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.stopPropagation()
  }
}
